<div class="container">
    <div class="card shadow">
        <div class="card-header bg-primary text-white">
            <div class="d-flex justify-content-between align-items-center flex-wrap">
                <!-- On mobile, this will stack nicely -->
                <h2 class="mb-0 mb-md-0 mb-2"><i class="fa fa-headphones"></i> RSA Service Entry</h2>
                <span class="badge bg-light text-dark fs-6 py-2 px-3">
                    <i class="fa fa-id-card me-1"></i>
                    {{selectedCertificate?.certificateNumber}}
                </span>
            </div>
        </div>
        <div class="card-body">
            <!-- Quick Actions Toolbar -->
            <div class="card bg-light mb-3 border-primary">
                <div class="card-header bg-primary text-white">
                    <i class="fa fa-bolt"></i> Quick Actions
                </div>
                <div class="card-body">
                    <!-- Certificate details with better mobile layout -->
                    <div class="row g-2 mb-3">
                        <div class="col-12">
                            <div class="d-flex align-items-center">
                                <div class="me-3">
                                    <i class="fa fa-info-circle fa-lg text-primary"></i>
                                </div>
                                <div class="flex-grow-1">
                                    <h6 class="mb-1">Certificate Details</h6>
                                    <div class="small text-muted mb-2">
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <div><strong>Owner:</strong> {{selectedCertificate?.firstName}} {{selectedCertificate?.lastName}}</div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <div><strong>Contact:</strong> {{selectedCertificate?.contactNumber}}</div>
                                            <button class="btn btn-sm btn-outline-secondary" 
                                                    (click)="onCopyToClipboard(selectedCertificate?.contactNumber)"
                                                    title="Copy contact number">
                                                <i class="fa fa-copy"></i>
                                            </button>
                                        </div>
                                        <div><strong>Vehicle:</strong> {{selectedCertificate?.vehicleMake}} {{selectedCertificate?.model}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <form [formGroup]="rsaProvidedForm" (ngSubmit)="onSubmit()">
                <!-- Customer Data Section -->
                <fieldset class="border p-3">
                    <legend class="w-auto">
                        <i class="fa fa-user-circle"></i> Customer Data
                    </legend>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-header">
                                    <i class="fa fa-map-marker"></i> Location Information
                                </div>
                                <div class="card-body">
                                    <div class="row g-2">
                                        <div class="form-group col-md-6">
                                            <label for="state" class="form-label">
                                                <i class="fa fa-map"></i> Customer State <span class="text-danger">*</span>
                                            </label>
                                            <select class="form-select form-control" formControlName="state">
                                                <option value="">Select State</option>
                                                <option *ngFor="let s of stateList" [value]="s">{{s}}</option>
                                            </select>
                                            <div *ngIf="submitted && rsaF.state.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.state.errors.required">State is required</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="city" class="form-label">
                                                <i class="fa fa-building"></i> Customer Pick up City <span class="text-danger">*</span>
                                            </label>
                                            <select class="form-select form-control" formControlName="city">
                                                <option value="">Select City</option>
                                                <option *ngFor="let c of cityList" [value]="c">{{c}}</option>
                                            </select>
                                            <div *ngIf="submitted && rsaF.city.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.city.errors.required">City is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-header">
                                    <i class="fa fa-phone"></i> Contact Information
                                </div>
                                <div class="card-body">
                                    <div class="row g-2">
                                        <div class="form-group col-md-6">
                                            <label for="callerName" class="form-label">
                                                <i class="fa fa-user"></i> Caller Name
                                            </label>
                                            <input type="text" formControlName="callerName" class="form-control" 
                                                [ngClass]="{ 'is-invalid': submitted && rsaF.callerName.errors }" 
                                                placeholder="Enter caller name" />
                                            <div *ngIf="submitted && rsaF.callerName.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.callerName.errors.required">Caller name is required</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="callbackNumber" class="form-label">
                                                <i class="fa fa-phone"></i> Call Back Number
                                            </label>
                                            <div class="input-group">
                                                <input type="number" formControlName="callbackNumber" class="form-control" 
                                                    [ngClass]="{ 'is-invalid': submitted && rsaF.callbackNumber.errors }" 
                                                    placeholder="Enter callback number" />
                                                <button type="button" class="btn btn-outline-secondary" (click)="onCopyToClipboard(rsaProvidedForm.value.callbackNumber)">
                                                    <i class="fa fa-copy"></i>
                                                </button>
                                            </div>
                                            <div *ngIf="submitted && rsaF.callbackNumber.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.callbackNumber.errors.required">Callback Number is required</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="rsaProvidedDate" class="form-label">
                                                <i class="fa fa-calendar"></i> Service Date & Time (IST)
                                            </label>
                                            <div class="input-group">
                                                <input type="datetime-local" formControlName="rsaProvidedDate" class="form-control" />
                                                <span class="input-group-text" title="India Standard Time"><i class="fa fa-globe"></i> IST</span>
                                            </div>
                                            <div class="form-text small text-muted">
                                                <i class="fa fa-info-circle"></i> All times are in India Standard Time (UTC+5:30)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                
                <!-- RSA Provider & Dealership Data Section -->
                <fieldset class="border p-3">
                    <legend class="w-auto">
                        <i class="fa fa-wrench"></i> RSA Provider & Dealership Data
                    </legend>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-header">
                                    <i class="fa fa-building"></i> Dealership Information
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="dealershipLocation" class="form-label">
                                            <i class="fa fa-map-marker"></i> Dealership Location <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" formControlName="dealershipLocation" class="form-control" 
                                            [ngClass]="{ 'is-invalid': submitted && rsaF.dealershipLocation.errors }" 
                                            placeholder="Enter dealership name/location" />
                                        <div *ngIf="submitted && rsaF.dealershipLocation.errors" class="invalid-feedback d-block">
                                            <div *ngIf="rsaF.dealershipLocation.errors.required">Dealership location is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-header">
                                    <i class="fa fa-users"></i> Service Provider Selection
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="provider" class="form-label">
                                            <i class="fa fa-ambulance"></i> City-wise Provider List <span class="text-danger">*</span>
                                        </label>
                                        <div class="input-group">
                                            <select class="form-select form-control" formControlName="provider" (change)="onProviderSelection($event.target.value)">
                                                <option value="">Select Provider</option>
                                                <option *ngFor="let p of providerList" [value]="p">{{p}}</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <span *ngIf="loading" class="input-group-text">
                                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </span>
                                        </div>
                                        <div *ngIf="submitted && rsaF.provider.errors" class="invalid-feedback d-block">
                                            <div *ngIf="rsaF.provider.errors.required">Provider is required</div>
                                        </div>
                                        <div *ngIf="providerList.length === 0 && !loading" class="form-text text-warning mt-1">
                                            <i class="fa fa-info-circle"></i> No providers available for selected location. You may select "Other".
                                        </div>
                                    </div>
                                    
                                    <!-- Display provider contact number if available -->
                                    <div *ngIf="selectedProviderContactNumber && rsaProvidedForm.value.provider !== 'Other'" class="mt-3">
                                        <div class="card border-success">
                                            <div class="card-header bg-success text-white">
                                                <i class="fa fa-phone-square"></i> Provider Contact
                                            </div>
                                            <div class="card-body p-3">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <span class="font-monospace fw-bold fs-5">{{selectedProviderContactNumber}}</span>
                                                    </div>
                                                    <button type="button" class="btn btn-sm btn-primary" (click)="onCopyToClipboard(selectedProviderContactNumber)">
                                                        <i class="fa fa-copy me-1"></i> Copy Number
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Reimbursement section for "Other" provider -->
                    <div class="row mt-3" *ngIf="rsaProvidedForm.value.provider === 'Other'">
                        <div class="col-12">
                            <div class="card border-warning">
                                <div class="card-header bg-warning text-dark">
                                    <i class="fa fa-money"></i> Reimbursement Details
                                </div>
                                <div class="card-body p-3">
                                    <div class="row g-3">
                                        <div class="form-group col-md-4">
                                            <label for="reimbursementAmount" class="form-label">
                                                <i class="fa fa-inr"></i> Reimbursement Amount <span class="text-danger">*</span>
                                            </label>
                                            <div class="input-group">
                                                <span class="input-group-text">₹</span>
                                                <input type="number" formControlName="reimbursementAmount" class="form-control" placeholder="Enter amount" />
                                            </div>
                                        </div>
                                        <div class="form-group col-md-8">
                                            <label for="reimbursementComment" class="form-label">
                                                <i class="fa fa-comment"></i> Reimbursement Comment <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" formControlName="reimbursementComment" class="form-control" placeholder="Enter comment for reimbursement" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                
                <!-- Financials Section -->
                <fieldset class="border p-3">
                    <legend class="w-auto">
                        <i class="fa fa-money"></i> Financials & Status
                    </legend>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-header">
                                    <i class="fa fa-calculator"></i> Service Costs & Details
                                </div>
                                <div class="card-body">
                                    <div class="row g-2">
                                        <div class="form-group col-md-6">
                                            <label for="distance" class="form-label">
                                                <i class="fa fa-road"></i> Distance <span class="text-danger">*</span>
                                            </label>
                                            <div class="input-group">
                                                <input type="number" formControlName="distance" class="form-control" 
                                                    [ngClass]="{ 'is-invalid': submitted && rsaF.distance.errors }" 
                                                    placeholder="Enter distance" />
                                                <span class="input-group-text">km</span>
                                            </div>
                                            <div *ngIf="submitted && rsaF.distance.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.distance.errors.required">Distance is required</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="serviceCost" class="form-label">
                                                <i class="fa fa-inr"></i> Service Cost <span class="text-danger">*</span>
                                            </label>
                                            <div class="input-group">
                                                <span class="input-group-text">₹</span>
                                                <input type="number" formControlName="serviceCost" class="form-control" 
                                                    [ngClass]="{ 'is-invalid': submitted && rsaF.serviceCost.errors }" 
                                                    placeholder="Enter cost" />
                                            </div>
                                            <div *ngIf="submitted && rsaF.serviceCost.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.serviceCost.errors.required">Service cost is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-header">
                                    <i class="fa fa-info-circle"></i> Status & Payment
                                </div>
                                <div class="card-body">
                                    <div class="row g-2">
                                        <div class="form-group col-md-6">
                                            <label for="serviceStatus" class="form-label">
                                                <i class="fa fa-tasks"></i> Service Status
                                            </label>
                                            <select class="form-select form-control" formControlName="serviceStatus">
                                                <option value="In progress">In progress</option>
                                                <option value="Completed">Completed</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="paidBy" class="form-label">
                                                <i class="fa fa-credit-card"></i> Paid By <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" formControlName="paidBy" class="form-control" 
                                                [ngClass]="{ 'is-invalid': submitted && rsaF.paidBy.errors }" 
                                                placeholder="Enter who paid" />
                                            <div *ngIf="submitted && rsaF.paidBy.errors" class="invalid-feedback d-block">
                                                <div *ngIf="rsaF.paidBy.errors.required">Paid By is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                
                <!-- Service History Section -->
                <fieldset class="border p-3">
                    <legend class="w-auto">
                        <i class="fa fa-history"></i> Service History
                    </legend>
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <div *ngIf="rsaProvidedForm.value.history && rsaProvidedForm.value.history.length > 0">
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover table-sm">
                                        <thead class="table-light">
                                            <tr>
                                                <th><i class="fa fa-calendar"></i> Date/Time</th>
                                                <th><i class="fa fa-info-circle"></i> Status</th>
                                                <th><i class="fa fa-comment"></i> Comment</th>
                                                <th><i class="fa fa-user"></i> Actioned By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let h of rsaProvidedForm.value.history">
                                                <td>{{h.modifiedTime | date:'MMM d, y h:mm a'}}</td>
                                                <td>
                                                    <span class="badge" 
                                                        [ngClass]="{'bg-success text-white': h.modifiedStatus === 'Completed', 'bg-warning text-dark': h.modifiedStatus === 'In progress'}">
                                                        <i [class]="h.modifiedStatus === 'Completed' ? 'fa fa-check-circle' : 'fa fa-clock-o'"></i>
                                                        {{h.modifiedStatus}}
                                                    </span>
                                                </td>
                                                <td>{{h.comment}}</td>
                                                <td><i class="fa fa-user-circle-o"></i> {{h.actionedBy}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div *ngIf="!rsaProvidedForm.value.history || rsaProvidedForm.value.history.length === 0" class="alert alert-info">
                                <i class="fa fa-info-circle"></i> No history entries yet. Add a comment below.
                            </div>
                            
                            <div class="form-group mt-3">
                                <label for="newHistoryComment" class="form-label">
                                    <i class="fa fa-comment"></i> Add Comment
                                </label>
                                <textarea class="form-control" [formControl]="newHistoryCommentControl" rows="3" 
                                    placeholder="Add a comment for this service update..."></textarea>
                                <div class="form-text mt-2">
                                    <i class="fa fa-info-circle"></i> Comments will be visible in the service history timeline
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                
                <!-- Mobile-friendly submit section with fixed position on small screens -->
                <div class="card bg-light p-3 mt-4 mb-3 fixed-bottom-action">
                    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <div class="mb-3 mb-md-0 w-100 d-flex gap-2">
                            <button [disabled]="loading" type="submit" class="btn btn-lg btn-primary flex-grow-1" style="min-height: 60px;">
                                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                <i class="fa fa-save me-2"></i> Save RSA Service
                            </button>
                            <button type="button" [disabled]="loading" (click)="onCancel()" class="btn btn-lg btn-secondary" style="min-height: 60px;">
                                <i class="fa fa-times me-2"></i> Cancel
                            </button>
                        </div>
                        <div class="text-center text-md-end mt-2 mt-md-0">
                            <span class="text-muted">Fields with <span class="text-danger fw-bold">*</span> are required</span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
